module.exports = __webpack_public_path__ + "img/dexag_gray.adcdfa4b.svg";